<template>
    <div id="home" :class="{
    'direction-rtl': language === 'he',
    'text-right': language === 'he',
    'text-left': language === 'en',
    'direction-ltr': language === 'en'}">
        <navbar></navbar>
        <div id="sections-area">
            <modal :mobile="mobile" :title="modal.title" v-show="modal.show" @close="updateModalVisibility({})">
                <template slot="body">
                    <component :is="modal.currentContent"></component>
                </template>
            </modal>
            <perpage-dev></perpage-dev>
            <opening></opening>
            <mvp-offer></mvp-offer>
            <services></services>
            <myths-busters></myths-busters>
            <rich-client></rich-client>
            <falafel></falafel>
            <tech></tech>
        </div>
        <contact></contact>
        <my-footer></my-footer>
        <mvp-form v-show="isMvpModalOpen" @close="updateMvpModalVisibility({})"></mvp-form>
        <img class="background-fixed-img" src="/img/background.jpg">
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import Navbar from '.././components/Navbar.vue';
    import PerPageDev from '../components/sections/Hero.vue';
    import Falafel from '.././components/sections/Falafel.vue';
    import MythsBusters from '.././components/sections/MythsBusters.vue';
    import RichClient from '.././components/sections/RichClient.vue';
    import Services from '.././components/sections/Services.vue';
    import Entrepreneur from '.././components/sections/Entrepreneur.vue';
    import Footer from '.././components/Footer.vue';
    import Contact from '.././components/Contact.vue';
    import About from '.././components/sections/About.vue';
    import Tech from '.././components/sections/Tech.vue';
    import Modal from '.././components/Modal.vue';
    import MockUp from '.././components/modalContent/MockUp.vue';
    import Social from '.././components/modalContent/Social.vue';
    import MVP from '.././components/modalContent/MVP.vue';
    import ECommerce from '.././components/modalContent/ECommerce.vue';
    import Freelancer from '.././components/modalContent/Freelancer.vue';
    import MobileApp from '.././components/modalContent/MobileApp.vue';
    import MobileNavMenu from '../components/modalContent/MobileNavMenu.vue';
    import Opening from '.././components/sections/Opening.vue';
    import MvpOffer from '.././components/sections/MvpOffer.vue';
    import MvpForm from '../components/modalContent/MvpForm.vue';

    export default {
        name: 'home',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
            ...mapGetters({
                mobile: 'layout/mobile',
                modal: 'layout/modal',
                isScrolled: 'layout/isScrolled',
                isMvpModalOpen: 'layout/isMvpModalOpen',
            }),
        },
        components: {
            'navbar': Navbar,
            'perpage-dev': PerPageDev,
            'falafel': Falafel,
            'myths-busters': MythsBusters,
            'rich-client': RichClient,
            'services': Services,
            'entrepreneur': Entrepreneur,
            'my-footer': Footer,
            'contact': Contact,
            'about': About,
            'tech': Tech,
            'modal': Modal,
            'mock-up': MockUp,
            'social': Social,
            'mvp': MVP,
            'ECommerce': ECommerce,
            'freelancer': Freelancer,
            'mobile-app': MobileApp,
            'mobile-nav-menu': MobileNavMenu,
            'opening': Opening,
            'mvp-offer': MvpOffer,
            'mvp-form': MvpForm,
        },
        methods: {
            ...mapActions({
                updateModalTitle: 'layout/updateModalTitle',
                updateModalVisibility: 'layout/updateModalVisibility',
                updateModalContent: 'layout/updateModalContent',
                updateIsScrolled: 'layout/updateIsScrolled',
                updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
            }),
            handleScroll () {
                return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
                    payload: {
                        scrolled: window.scrollY,
                    },
                });
            },
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll);
        },
    }
</script>
<style lang="css" scoped>
    .background-fixed-img{
        left: 0;
        width: 100%;
        height: auto;
        opacity: 1;
        position: fixed;
        right: 0;
        top: -870px;
        transition: opacity 1s;
        z-index: -1;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .background-fixed-img {
            left: -30%;
            width: 160%;
            height: auto;
            opacity: 1;
            position: fixed;
            right: 0;
            top: 0;
            transition: opacity 1s;
            z-index: -1;
        }
    }
    .direction-ltr {
        direction: ltr !important;
    }
    .direction-rtl {
        direction: rtl !important;
    }
</style>
